import { IFlightItem } from "@/components/FlightRow/FlightRow";

function getFlightStatus(flightItem: IFlightItem, lang: string): string {
  if (flightItem.statusPubblicDescription == null) {
    const estimatedDate = new Date(flightItem.estimatedTime);
    const scheduledDate = new Date(flightItem.scheduledTime);
    const differenceInMillis = estimatedDate.getTime() - scheduledDate.getTime();
    const maxDelayTime = 900000; // millisecondi [15 min]

    return differenceInMillis > maxDelayTime ? DELAY_STATUS[lang] : '';
  }

  return flightItem.statusPubblicDescription;
}

const DELAY_STATUS: any = {
  it: 'RITARDO',
  en: 'DELAY'
}


export default getFlightStatus;
